import React, { type FC } from 'react';
import { useFieldView } from '../contexts/form-view-context';
import { isInputField } from '../ui/form/types';
import { calculateGridStyles } from '../utils/grid-styles';
import { type FieldLayoutProps } from './field-layout';

export const DefaultFieldLayout: FC<FieldLayoutProps> = ({
  fieldId,
  ...rest
}) => {
  const fieldView = useFieldView(fieldId);
  if (!fieldView) {
    return null;
  }

  const { layout, fieldType } = fieldView;
  const dataHook = `form-field-${
    isInputField(fieldView) ? fieldView.target : fieldView.id
  }`;

  const dataAttributes = {
    'data-hook': dataHook,
    'data-field-type': fieldType,
  };

  const gridStyles = calculateGridStyles({ layout });

  if ('children' in rest) {
    return (
      <div style={gridStyles.container} {...dataAttributes}>
        {rest.children}
      </div>
    );
  }

  const { renderLabel, renderInput, renderDescription } = rest;

  return (
    <>
      <div style={gridStyles.label}>{renderLabel()}</div>
      <div style={gridStyles.input} {...dataAttributes}>
        {renderInput()}
        {renderDescription()}
      </div>
    </>
  );
};
